import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e7a6dde"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "my-header" };
const _hoisted_2 = ["id"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "dialog-body" };
const _hoisted_5 = {
    key: 0,
    class: "dialog-footer"
};
const _hoisted_6 = /*#__PURE__*/ _createTextVNode("取消");
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("确定");
import { debounce } from "@/utils";
import CloudButton from "../CloudButton/index.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        showFooter: { type: Boolean, default: true },
        showClose: { type: Boolean, default: true },
        title: { default: "" },
        titleIcon: { default: "" },
        width: { default: 800 },
        loading: { type: Boolean, default: false }
    },
    emits: ["dialogClose", "dialogSuccess", "dialogOpen"],
    setup(__props, { emit }) {
        const closeHandle = () => {
            emit("dialogClose", false);
        };
        const openHandle = () => {
            emit("dialogOpen", true);
        };
        const confirm = debounce(() => {
            emit("dialogSuccess", false);
        }, 300, true);
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                class: _normalizeClass(["my-dialog", { 'icon-title': __props.titleIcon }]),
                width: __props.width,
                "show-close": false,
                "close-on-click-modal": false,
                "align-center": true,
                onClose: closeHandle,
                onOpen: openHandle
            }, {
                header: _withCtx(({ close, titleId }) => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            id: titleId,
                            class: "title-style display-flex align-items"
                        }, [
                            (__props.titleIcon)
                                ? (_openBlock(), _createBlock(_component_svg_icon, {
                                    key: 0,
                                    "icon-class": __props.titleIcon,
                                    class: "frame-icon"
                                }, null, 8, ["icon-class"]))
                                : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "title", {}, () => [
                                _createTextVNode(_toDisplayString(__props.title), 1)
                            ])
                        ], 8, _hoisted_2),
                        (__props.showClose)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "close-box display-flex align-items",
                                onClick: close
                            }, [
                                _createVNode(_component_svg_icon, {
                                    "icon-class": "close",
                                    class: "close-icon"
                                })
                            ], 8, _hoisted_3))
                            : _createCommentVNode("", true)
                    ])
                ]),
                footer: _withCtx(() => [
                    (__props.showFooter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createVNode(CloudButton, {
                                type: "light",
                                size: "large",
                                onClick: closeHandle
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_6
                                ]),
                                _: 1
                            }),
                            _createVNode(CloudButton, {
                                type: "deep",
                                size: "large",
                                loading: __props.loading,
                                onClick: _unref(confirm)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_7
                                ]),
                                _: 1
                            }, 8, ["loading", "onClick"])
                        ]))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "footer")
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                _: 3
            }, 8, ["class", "width"]));
        };
    }
});
